import { VERIFICATION } from "../../constants";

export const setDocumentType = (documentType) => ({
  type: VERIFICATION.SET_DOCUMENT_TYPE,
  payload: documentType,
});